import { Text } from '@shared-ui/components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Hint shown above the page while the browser reports it is offline.
 *
 * `navigator.onLine` comes from the OS network interfaces, not from whether
 * the API is reachable, and Chrome can leave it stuck on `false` (after sleep,
 * a pending update or a VPN change) while requests still work. So it never
 * hides the page; real network failures surface through the API errors.
 */
export const OfflineNotice = () => {
    const { t } = useTranslation(['common'])
    const [isOnline, setIsOnline] = useState(navigator.onLine)

    useEffect(() => {
        const handleOnlineStatusChange = () => {
            setIsOnline(navigator.onLine)
        }

        window.addEventListener('online', handleOnlineStatusChange)
        window.addEventListener('offline', handleOnlineStatusChange)

        return () => {
            window.removeEventListener('online', handleOnlineStatusChange)
            window.removeEventListener('offline', handleOnlineStatusChange)
        }
    }, [])

    if (isOnline) return null

    return (
        <div
            role="status"
            className="mb-2 rounded-lg bg-background-base px-3 py-2"
        >
            <Text
                className="text-center text-sm font-normal text-darkBlue80"
                variant="contained"
                text={t('error-states.offline')}
            />
        </div>
    )
}
